





import { Vue, Component } from "vue-property-decorator";

import AdminOrderHistory from "@/components/admin-customer/orderHistory.vue";

@Component({
  name: "AdminOrderHistoryPage",
  components: {
    AdminOrderHistory,
  },
})
export default class AdminOrderHistoryPage extends Vue {}
